 document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.product-grid-slider').forEach((item) => {
      new Splide(item, {
          type: 'loop',
          perPage: 4,
          perMove: 1,
          gap: '30px',
          autoplay: false,
          pagination: false,
          arrows: false,
          breakpoints: {
            1024: {
              perPage: 3,
            },
            991: {
              perPage: 2,
              gap: '10px',
              arrows: false,
              pagination: true,
            },
            480: {
              perPage: 1,
            },
          },
      }).mount();
    });


    var imageEl = document.querySelector('.testimonials-image-slider');
    var messageEl = document.querySelector('.testimonials-message-slider');

    if (!imageEl || !messageEl) return;

    // Make sure slides exist
    if (
        imageEl.querySelectorAll('.splide__slide').length === 0 ||
        messageEl.querySelectorAll('.splide__slide').length === 0
    ) return;

    var imageSplide = new Splide(imageEl, {
        type: 'loop',
        pagination: false,
        arrows: false,
        isNavigation: true,
        focus: 'center',
        gap: '0px',
        perPage: 5,
        perMove: 1
    });

    var messageSplide = new Splide(messageEl, {
        type: 'loop',
        pagination: true,
        arrows: false,
        speed: 600,
        drag: true,
    });

    // 🔑 NAV slider must mount first
    imageSplide.mount();
    messageSplide.sync(imageSplide).mount();


 });

//  Faq

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faq').forEach((faq) => {
    faq.addEventListener('click', function (e) {
      const header = e.target.closest('.faq-header');
      if (!header) return;

      const item = header.closest('.faq-item');
      const content = item.querySelector('.faq-content');

      // Close other items
      faq.querySelectorAll('.faq-item').forEach((el) => {
        if (el !== item) {
          closeItem(el);
        }
      });

      // Toggle current item
      if (item.classList.contains('active')) {
        closeItem(item);
      } else {
        openItem(item);
      }
    });
  });

  function openItem(item) {
    const content = item.querySelector('.faq-content');
    item.classList.add('active');

    content.style.height = content.scrollHeight + 'px';

    content.addEventListener('transitionend', function handler() {
      content.style.height = 'auto';
      content.removeEventListener('transitionend', handler);
    });
  }

  function closeItem(item) {
    const content = item.querySelector('.faq-content');

    content.style.height = content.scrollHeight + 'px';
    content.offsetHeight;

    content.style.height = '0px';
    item.classList.remove('active');
  }
});

if ((customerSlider = document.querySelector(".customer-sayslide"))) {
    const e = new Splide(customerSlider, {
        type: "slide",
        perPage: 3,
        perMove: 1,
        gap: "3rem",
        pagination: !1,
        arrows: false,
        breakpoints: { 640: { perPage: 1, gap: "1rem" }, 992: { perPage: 2, gap: "1.5rem" }, 1500: { perPage: 2 } },
    });
    e.on("mounted", () => {
        customerSlider.querySelector(".splide__arrows") && customerSlider.classList.add("has-arrows");
    }),
        e.mount();
}